import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';
import { hasFeature } from '@/lib/utils/features';
import { bootstrapSession } from '@/lib/utils/session';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute('/(client)/orders')({
  // The layout route for every orders screen, so the feature and the read
  // permission are asked once here rather than on each of the thirty-odd
  // children — and a typed URL cannot slip past them.
  beforeLoad: async ({ location }) => {
    const user = useSessionStore.getState().user ?? (await bootstrapSession());
    if (!hasFeature(user, 'cascade-tracing')) {
      throw redirect({ to: '/dashboard' });
    }

    const perms = await ensurePermissions();
    if (!perms.orders.canRead) {
      throw redirect({ to: '/dashboard' });
    }

    if (location.pathname === '/orders' || location.pathname === '/orders/') {
      throw redirect({
        to: '/orders/sales-orders/active',
        search: { aiSummaryId: undefined, aiOrderNumber: undefined },
      });
    }
  },
});
